import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTitle } from '../../../Application';
import PasswordResetView from '../../../ui/components/PasswordReset/PasswordReset';
import {requestResetPwMail} from "../../../connectors/Users/actions";

import {t} from 'i18next'
import { pingURL, sendRequest } from '../../../services/api/apiClient';
import toast from '../../../utils/ToasterService';

const title = 'Password zurücksetzen';

const mapStateToProps = state => ({
  title: state.application.title,
});

const mapDispatchToProps = dispatch => ({
  
  requestResetPwMail: (email, successCb, errorCb) => dispatch(requestResetPwMail(email, successCb, errorCb))
});

/**
 * PasswordForgot
 */
class PasswordForgotSendMail extends PureComponent {
  static propTypes = {
  }

  static defaultProps = {
  }

  checkConnectionToServer=()=>{
    sendRequest('get', pingURL)
    .then(() => {
      //console.log('Response Ok: Server working!');
    })
    .catch(error => {
      //console.error('Cannot Connect to Server:', error);
      //Server Failure Toast here
      toast.error(t('Global.toast_server_disconnect'));
    });
  }

  render() {
    this.checkConnectionToServer()
    return (
      <PasswordResetView onRequestResetMail={this.props.requestResetPwMail}
                         router={this.props.history}
      />
    );
  }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordForgotSendMail)), title);
